import { useState } from 'react';

export type DayView = 'timeline' | 'calendar';
const KEY = 'planer-day-view';

function read(): DayView {
  try {
    return localStorage.getItem(KEY) === 'calendar' ? 'calendar' : 'timeline';
  } catch {
    return 'timeline';
  }
}

/** Timeline by default; the last choice is remembered on this device. */
export function useDayView(): [DayView, (v: DayView) => void] {
  const [view, setView] = useState<DayView>(read);
  return [
    view,
    (v) => {
      setView(v);
      try {
        localStorage.setItem(KEY, v);
      } catch {
        // storage unavailable: keep it for this session
      }
    },
  ];
}
